var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('ThemedLoading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": false,
      "loader": "bars",
      "opacity": 0
    }
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card py-2"
  }, [_c('div', {
    staticClass: "card-body py-4"
  }, [_c('ValidationObserver', {
    ref: "form",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          on: {
            "submit": function ($event) {
              $event.preventDefault();
              return handleSubmit(_vm.handleCompanyForm);
            },
            "reset": function ($event) {
              $event.preventDefault();
              return _vm.handleReset.apply(null, arguments);
            }
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-12 mb-4"
        }, [_c('ValidationProvider', {
          attrs: {
            "vid": `name`,
            "name": "Name",
            "rules": "required"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var errors = _ref2.errors;
              return [_c('div', {
                staticClass: "form-group"
              }, [_c('label', {
                attrs: {
                  "for": "name"
                }
              }, [_vm._v(_vm._s(_vm.$t("Name")))]), _c('input', {
                directives: [{
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.name,
                  expression: "form.name"
                }],
                staticClass: "form-control",
                attrs: {
                  "type": "text",
                  "id": "name",
                  "placeholder": "Name"
                },
                domProps: {
                  "value": _vm.form.name
                },
                on: {
                  "input": function ($event) {
                    if ($event.target.composing) return;
                    _vm.$set(_vm.form, "name", $event.target.value);
                  }
                }
              }), _c('small', {
                staticClass: "form-text text-danger"
              }, [_vm._v(_vm._s(errors[0]))])])];
            }
          }], null, true)
        }), _c('ValidationProvider', {
          attrs: {
            "vid": `country`,
            "name": "Country",
            "rules": "required"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var errors = _ref3.errors;
              return [_c('div', {
                staticClass: "form-group"
              }, [_c('label', {
                attrs: {
                  "for": "country"
                }
              }, [_vm._v(_vm._s(_vm.$t("Country")))]), _c('v-select', {
                attrs: {
                  "placeholder": "Country",
                  "options": _vm.countries,
                  "label": "name",
                  "reduce": function (country) {
                    return country.id;
                  },
                  "required": ""
                },
                model: {
                  value: _vm.form.countryId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "countryId", $$v);
                  },
                  expression: "form.countryId"
                }
              }), _c('small', {
                staticClass: "form-text text-danger"
              }, [_vm._v(_vm._s(errors[0]))])], 1)];
            }
          }], null, true)
        }), _c('div', {
          staticClass: "form-group"
        }, [_c('label', {
          attrs: {
            "for": "contactEmail"
          }
        }, [_vm._v(_vm._s(_vm.$t("create_company_form.contact_email")))]), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.form.contactEmail,
            expression: "form.contactEmail"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "email",
            "id": "contactEmail",
            "placeholder": "Email"
          },
          domProps: {
            "value": _vm.form.contactEmail
          },
          on: {
            "input": function ($event) {
              if ($event.target.composing) return;
              _vm.$set(_vm.form, "contactEmail", $event.target.value);
            }
          }
        })]), _c('div', {
          staticClass: "form-group"
        }, [_c('label', {
          attrs: {
            "for": "contactPhone"
          }
        }, [_vm._v(_vm._s(_vm.$t("create_company_form.contact_email")))]), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.form.contactPhone,
            expression: "form.contactPhone"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "tel",
            "id": "contactPhone",
            "placeholder": "Phone number"
          },
          domProps: {
            "value": _vm.form.contactPhone
          },
          on: {
            "input": function ($event) {
              if ($event.target.composing) return;
              _vm.$set(_vm.form, "contactPhone", $event.target.value);
            }
          }
        })])], 1)]), _c('div', {
          staticClass: "row mt-4"
        }, [_c('div', {
          staticClass: "col-md-12 d-flex justify-content-end"
        }, [_c('div', {
          staticClass: "form-group"
        }, [_c('button', {
          staticClass: "btn btn-outline-secondary mr-2",
          attrs: {
            "type": "reset"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]), _c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "type": "submit"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("Create")) + " ")])])])])])];
      }
    }])
  })], 1)])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }